import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { companyAutocompleteQueryKeys } from "./queryKeyFactory";

export const MAX_RESULTS = 8;

const useCompanyAutocompleteQuery = (
    term: string,
    maxResults: number = MAX_RESULTS,
    withDataCredits: boolean = false,
) => {
    return useQuery({
        queryKey: companyAutocompleteQueryKeys.companyAutocomplete(term),
        queryFn: async ({ signal }) => {
            return salesApiService.getAutocompleteCompanies(
                { term, size: maxResults, withDataCredits },
                {
                    cancellation: signal,
                },
            );
        },
        enabled: !!term,
        staleTime: Infinity,
    });
};

export default useCompanyAutocompleteQuery;
